import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RadioButton from '@material-ui/core/Radio';

import { Wrapper, LabelWrapper } from './Radio.style';
import Tooltip from '../Tooltip/Tooltip';

/**
 *
 * Code ported from web-app (app/components/presentational/common/Radio/Radio.jsx)
 *
 */
const Radio = ({
  isSelected,
  handleChange,
  label,
  value,
  radioGroupName,
  ariaLabel,
  disabled,
  tooltipText,
}) => {
  const [openTooltip, setOpenTooltip] = useState(false);

  return (
    <Wrapper
      value={value}
      label={<LabelWrapper>{label}</LabelWrapper>}
      disabled={disabled}
      control={
        <Tooltip title={tooltipText} position="top" open={openTooltip}>
          <RadioButton
            checked={isSelected}
            onChange={handleChange}
            color="default"
            name={radioGroupName}
            value={value}
            inputProps={{ 'aria-label': ariaLabel }}
            size="medium"
            classes={{ checked: 'selected' }}
            disabled={disabled}
          />
        </Tooltip>
      }
      onMouseEnter={() => setOpenTooltip(true)}
      onMouseLeave={() => setOpenTooltip(false)}
    />
  );
};

Radio.propTypes = {
  /**
   * User-facing text for the radio
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  /**
   * Value of the radio, not visible to the user
   */
  value: PropTypes.string.isRequired,
  /**
   * Optional: If provided, it will appear as a tooltip
   */
  tooltipText: PropTypes.string,
  /**
   * Accessible label for the radio button
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * A radio group is defined by giving each of radio buttons in the group the same name.
   */
  radioGroupName: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
};

Radio.defaultProps = {
  disabled: false,
  tooltipText: '',
  radioGroupName: '',
  handleChange: () => {},
};

export default Radio;
